import { ArtifactType } from '@bymason/controller-api-hooks';

export type SelectionType = 'apk' | 'splash' | 'bootanimation' | 'config';
export type ErrorReason =
  | 'apk-media-upload-error'
  | 'config-load-error'
  | 'config-parse-error'
  | 'over-max-upload'
  | 'file-rejected';

const defaultErrorMessageMap: Record<ErrorReason, string> = {
  'apk-media-upload-error': 'File could not be uploaded',
  'config-load-error': 'Configuration file was unloadable',
  'config-parse-error': "Configuration content couldn't be parsed",
  'over-max-upload': 'Please upload one file at a time',
  'file-rejected': 'File was not uploaded because the file type was incompatible',
};

export const getErrorMessageFromReason = (reason: ErrorReason) => {
  return defaultErrorMessageMap[reason];
};

export interface selectionTypeDefault {
  extensions: string[];
  artifactType: string;
}

export const ARTIFACT_SELECTION_DEFAULTS: Map<SelectionType, selectionTypeDefault> = new Map([
  [
    'apk',
    {
      extensions: ['.apk'],
      artifactType: ArtifactType.Apk,
    },
  ],
  [
    'splash',
    {
      extensions: ['.png'],
      artifactType: ArtifactType.Media,
    },
  ],
  [
    'bootanimation',
    {
      extensions: ['.zip'],
      artifactType: ArtifactType.Media,
    },
  ],
  [
    'config',
    {
      extensions: ['.yaml', '.yml'],
      artifactType: ArtifactType.Config,
    },
  ],
]);
